// صندوق شرح الحسابات + تحذير العطل غير المدفوعة + التذييل.
import { esc, today } from "./reportFormat";
import { signature } from "./reportPages";

export const explain = (data, L) => {
  const lines = L.explain
    .map(([term, text]) => `<div><span class="b">${esc(term)}:</span> ${esc(text.replace("{m}", data.absence_multiplier))}</div>`)
    .join("");
  return `<div class="explain"><div class="b">${esc(L.explainTitle)}</div>${lines}</div>`;
};

export const warning = (data, L, { custom }) => {
  const names = (data.weekend_days || []).map((day) => L.weekdays[day] || day).join(" · ") || L.none;
  const reasons = custom ? "" : `<ul>${L.notPaidWhen.map((r) => `<li>${esc(r)}</li>`).join("")}</ul>`;
  return `<div class="warn">
    <div class="title">${esc(L.warnTitle)}</div>
    <div><span class="b">${esc(L.weekendIs)}</span> ${esc(names)}</div>
    <div>${esc(L.paidWhen)}</div>
    ${reasons}
  </div>`;
};

export const footer = (L, pages = 1) =>
  `${signature(L)}<div class="footer">${esc(L.footer)} | ${today()} | ${esc(
    L.pageOf.replace("{i}", pages).replace("{n}", pages),
  )}</div>`;
